import { intl } from './intl';

export const { t: statusesT, Message: StatusesMessage } = intl.createMessages({
    error: {
        ru: 'Ошибка',
        en: 'Error',
    },
    processing: {
        ru: 'Обрабатывается',
        en: 'Processing',
    },
    published: {
        ru: 'Опубликовано',
        en: 'Published',
    },
    ready: {
        ru: 'Готово',
        en: 'Ready',
    },
    waitUploading: {
        ru: 'Загружается',
        en: 'Uploading',
    },
    uploading: {
        ru: 'Загрузка',
        en: 'Upload',
    },
    success: {
        ru: 'Готово',
        en: 'Done',
    },
    pending: {
        ru: 'Ожидание',
        en: 'Pending',
    },
    unknown: {
        ru: 'Неизвестная ошибка',
        en: 'Unknown error',
    },
});
